import React, { memo } from "react";
import { Box, Grid, LinearProgress, makeStyles } from "@material-ui/core";

import NoData from "./NoData";
import ExportButtonContainer from "../Export/ExportButtonContainer";

const Consumption = memo(
  ({ noData, isLoading, LegendComponent, ChartComponent, TableComponent }) => {
    if (isLoading) {
      return (
        <Box marginTop={2}>
          <LinearProgress color="secondary" />
        </Box>
      );
    }

    if (noData) {
      return (
        <>
          <NoData />
          {LegendComponent}
        </>
      );
    }

    return (
      <>
        {ChartComponent}

        {LegendComponent}
        <Box marginY={2}>{TableComponent}</Box>

        <Grid container spacing={2}>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" marginTop={1}>
                  <ExportButtonContainer currentView="consumption" />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
);

export default Consumption;
